import React, { useContext, useEffect, useState, useCallback, useMemo, useRef } from "react";
import Accordion from "react-bootstrap/Accordion";
import Spinner from "react-bootstrap/Spinner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useUnidades } from "../../../hooks/test/useUnidades";
import { Spinner as Load } from "../../Spinner";
import { FormularioBitacora } from "../../EnRuta/forms/FormularioBitacora";
import Swal from "sweetalert2";
import { SocketContext } from "../../../context/SocketContext";
import { formatDate } from "../../../helpers/formatDate";
import { AuthContext } from "../../../context/authContext/authContext";
import { GoogleMap, useJsApiLoader, Marker, Polyline, DirectionsRenderer, InfoWindow } from "@react-google-maps/api";
import { RegistrarEditarEventoRoboCamiones } from "../../customComponents/Modals/RegistrarEditarEventoRoboCamiones";
import logotp_ma from "../../../assets/img/logos/logo Total Protect.png";
import {
  faXmark,
  faCheck,
  faX,
  faTruck,
  faUserSecret,
  faTrailer,
} from "@fortawesome/free-solid-svg-icons";
import { TarjetaAperturaUnidad } from "../components/TarjetaAperturaUnidad";

export const FormatoEnRuta = ({
  unidad,
  viaje,
  getUnidades = () => { },
  hideSidebar = () => { },
}) => {
  const demoFancyMapStyles = require("../../../components/jsonstyleMap/demoFancyMapStyles.json");
  const { user } = useContext(AuthContext);
  const [formatoCheck, setFormatoCheck] = useState({});
  const { socket } = useContext(SocketContext);
  const {
    getBitacoraViaje,
    getTiendasViaje,
    getTripulacionViaje,
    getCheckPruebaViaje,
    getOperadorViaje,
    postBitacora,
    putViajeStatusV2,
    getViaje,
    putCoordenadas,
  } = useUnidades();
  const [operador, setOperador] = useState();
  const [chofer, setChofer] = useState();
  const [tiendasSeleccionadas, setTiendasSeleccionadas] = useState([]);
  const [tripulacion, setTripulacion] = useState([]);
  const [bitacora, setBitacora] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isChange, setIsChange] = useState(false);
  const [loadingComponente, setLoadingComponente] = useState(false);
  const [flujo, setFlujo] = useState(null);
  const [seguimiento, setSeguimiento] = useState();
  const [actiModal, setActiModal] = useState(false);
  const modalClose = () => setActiModal(false);
  const [idUnidad, setIdUnidad] = useState();
  const [actEventSeguridad, setActEventSeguridad] = useState(null);
  const [directions, setDirections] = useState(null);
  const [mapaListo, setMapaListo] = useState(false);
  const [infoAbierta, setInfoAbierta] = useState(null);
  const [form, setForm] = useState({
    unidad: "",
    notas: "",
    ultimo_evento: "",
    direccion: "",
    lat: "",
    long: "",
    bitacora_monitorista_id: "",
  });

  const rutaCoords = useMemo(() => {
    return [...bitacora]
      .sort((a, b) => new Date(a.bitacora_fecha_hora) - new Date(b.bitacora_fecha_hora))
      .filter(p => p.latitud !== 0 && p.longuitud !== 0) // descarta puntos sin coords
      .map(p => ({ lat: p.latitud, lng: p.longuitud }));
  }, [bitacora]);

  const mapRef = useRef(null);

  useEffect(() => {
    if (!viaje?.viaje_id) return;

    const fetchData = async () => {
      await getInfo(viaje.viaje_id);
    };

    fetchData();
  }, [viaje?.viaje_id, isChange]);

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.GOOGLE_MAPS_API_KEY
      ? process.env.GOOGLE_MAPS_API_KEY
      : "AIzaSyD6ekb2qbmZ3p9qfsi56PfuUKQt71fMMHg", //"AIzaSyAUjS4TZ1KxdAe113gf698s2o4WYGf-byc"
  });

  useEffect(() => {
    if (!isLoaded || rutaCoords.length < 2) return;

    const directionsService = new window.google.maps.DirectionsService();

    const origin = rutaCoords[0];
    const destination = rutaCoords[rutaCoords.length - 1];

    const MAX_WP = 23;
    const intermedios = rutaCoords.slice(1, -1);

    const waypoints = (intermedios.length > MAX_WP
      ? intermedios.filter((_, i) => i % Math.ceil(intermedios.length / MAX_WP) === 0)
      : intermedios
    ).map(coord => ({
      location: new window.google.maps.LatLng(coord.lat, coord.lng),
      stopover: false,
    }));

    directionsService.route(
      {
        origin,
        destination,
        waypoints,
        travelMode: window.google.maps.TravelMode.DRIVING,
        optimizeWaypoints: false, // false = respeta el orden cronológico
      },
      (result, status) => {
        console.log("Directions status:", status);
        console.log("rutaCoords al calcular:", rutaCoords);
        if (status === "OK") {
          setDirections(result);
        } else {
          console.error("Error al calcular ruta:", status);
        }
      }
    );
  }, [isLoaded, rutaCoords]);

  const marcadoresOrdenados = useMemo(() => {
    return [...bitacora]
      .filter(p => p.latitud !== 0 && p.longuitud !== 0)
      .sort((a, b) => new Date(a.bitacora_fecha_hora) - new Date(b.bitacora_fecha_hora))
      .map((p, i) => ({ ...p, numero: i + 1 }));
  }, [bitacora]);

  const onMapLoad = useCallback((map) => {
    mapRef.current = map;
    setMapaListo(true);
  }, []);

  useEffect(() => {
    if (!mapRef.current || !mapaListo || marcadoresOrdenados.length === 0) return;

    const timer = setTimeout(() => {
      if (marcadoresOrdenados.length === 1) {
        mapRef.current.setCenter({ lat: marcadoresOrdenados[0].latitud, lng: marcadoresOrdenados[0].longuitud });
        mapRef.current.setZoom(15);
        return;
      }
      const bounds = new window.google.maps.LatLngBounds();
      marcadoresOrdenados.forEach(p => bounds.extend({ lat: p.latitud, lng: p.longuitud }));
      mapRef.current.fitBounds(bounds);
    }, 100);

    return () => clearTimeout(timer);
  }, [marcadoresOrdenados, mapaListo]);

  const clearAll = () => {
    setTripulacion([]);
    setOperador({});
    setBitacora([]);
    setTiendasSeleccionadas([]);
    setDirections(null);
    setInfoAbierta(null);
  };

  const normalizarSeguridad = (seguridad) => {
    if (!seguridad) return [];

    const filas = [];

    if (seguridad.inicio_evento) {
      filas.push({
        esTipoSeguridad: true,
        bitacora_fecha_hora: seguridad.inicio_evento.fecha_hora,
        status: { nombre: seguridad.inicio_evento.evento, color: "#dc3545", icon: "fa-solid fa-shield-exclamation" },
        notas: seguridad.inicio_evento.descripcion,
      });
    }

    if (seguridad.seguimiento) {
      filas.push({
        esTipoSeguridad: true,
        bitacora_fecha_hora: seguridad.seguimiento.fecha_hora,
        status: { nombre: seguridad.seguimiento.estatus, color: "#fd7e14", icon: "fa-solid fa-shield-halved" },
        notas: seguridad.seguimiento.descripcion,
      });
    }

    return filas;
  };

  const registrosCombinados = useMemo(() => {
    const filasSeguridad = normalizarSeguridad(actEventSeguridad);
    const todo = [...bitacora, ...filasSeguridad];

    // Ordena de más antiguo a más reciente (invierte para mostrar el más reciente primero)
    return todo.sort((a, b) =>
      new Date(b.bitacora_fecha_hora) - new Date(a.bitacora_fecha_hora)
    );
  }, [bitacora, actEventSeguridad]);

  const getInfo = useCallback(async (viaje_id) => {
    try {
      clearAll();
      setLoadingComponente(true);

      // =========================
      // BITÁCORA + ÚLTIMO EVENTO
      // =========================
      const respBitacora = await getBitacoraViaje(viaje_id);

      if (respBitacora.ok) {
        const bitacoraFiltrada = respBitacora.bitacora.filter(evento => evento?.status?.nombre?.trim().toUpperCase() !== "SEGUIMIENTO").reverse();
        // const bitacora = [...respBitacora.bitacora].reverse();
        setBitacora(bitacoraFiltrada);
        setActEventSeguridad(respBitacora?.bitacora_seguridad);

        if (respBitacora.ultimo) {
          const ultimo = respBitacora.ultimo;

          setForm((prevForm) => ({
            ...prevForm,
            notas: ultimo.notas,
            ultimo_evento: ultimo.status?.nombre,
            direccion: ultimo.direccion,
            lat: prevForm.lat ?? ultimo.latitud,
            long: prevForm.long ?? ultimo.longuitud,
            bitacora_monitorista_id: ultimo.bitacora_monitorista_id
          }));

          setSeguimiento(ultimo);
        }
      }

      // =========================
      // VIAJE
      // =========================
      const respViaje = await getViaje(viaje_id);

      if (respViaje.ok) {
        setFlujo(respViaje.flujo_id);
        // =========================
        // OPERADORES
        // =========================
        setOperador(respViaje?.chofer);
        setChofer(respViaje?.operador);
        // =========================
        // TRIPULACIÓN
        // =========================
        if (respViaje.tripulantes_viajes.length !== 0) {

          setTripulacion(respViaje.tripulantes_viajes);
        } else {
          setTripulacion([]);
        }
      }

      // =========================
      // TIENDAS
      // =========================
      const respTiendas = await getTiendasViaje(viaje_id);

      if (respTiendas.ok && respTiendas.rutas) {
        const tiendasActivas = respTiendas.rutas.filter(
          (tienda) => tienda.isActive === 1
        );
        setTiendasSeleccionadas(tiendasActivas);
      } else {
        setTiendasSeleccionadas([]);
      }

      // =========================
      // CHECK PRUEBA
      // =========================
      const respCheck = await getCheckPruebaViaje(viaje_id);
      if (respCheck.ok) {
        setFormatoCheck({ ...respCheck });
      }

    } catch (error) {
      console.error("Error cargando información del viaje:", error);
    } finally {
      setLoadingComponente(false);
    }
  }, []);

  const actualizarUltimoEvento = async (viaje_id) => {
    let resp = await getBitacoraViaje(viaje_id);
    if (resp.ok) {
      console.log(resp.ultimo);
      setForm((prevForm) => ({
        ...prevForm,
        notas: resp.ultimo.notas,
        ultimo_evento: resp.ultimo.status.nombre,
        direccion: resp.ultimo.direccion,
        lat: prevForm.lat || resp.ultimo.latitud,
        long: prevForm.long || resp.ultimo.longuitud,
        bitacora_monitorista_id: resp.ultimo.bitacora_monitorista_id
      }));

      setSeguimiento(resp.ultimo);
    }
  }

  const containerStyle = {
    width: "auto",
    height: "400px",
  };

  const liberarUnidad = async () => {
    setLoading(true);

    let resp = await putViajeStatusV2(viaje.viaje_id, 8);
    if (!resp.ok) {
      setLoading(false);
      Swal.fire({
        title: "No se pudo liberar la unidad",
        text: resp.msg,
        icon: "error",
      });
    }

    if (resp.ok) {
      resp = await postBitacora({
        id_viaje: viaje.viaje_id,
        notas: "La unidad fue puesta de regreso a origen",
        id_status: 7,
      });
      resp = await postBitacora({
        id_viaje: viaje.viaje_id,
        notas: "La unidad fue liberada",
        id_status: 8,
      });
      setLoading(false);
      Swal.fire({
        title: "Unidad liberada",
        text: "La unidad ha sido liberada",
        icon: "success",
      });

      socket.emit("bitacora_dinamica", { idNegocio: unidad.negocio_id });
    }

    socket.emit("traer-unidades-en-ruta_", { idNegocio: unidad.negocio_id });
    hideSidebar();
  };

  const liberarUnidadViajeAutomatico = async () => {
    console.log("liberarUnidadViajeAutomatico....");
    setLoading(true);
    let resp = await putViajeStatusV2(viaje.viaje_id, 8);
    setLoading(false);
    if (!resp.ok)
      Swal.fire({
        title: "No se pudo liberar la unidad",
        text: resp.msg,
        icon: "error",
      });

    resp = await postBitacora({
      id_viaje: viaje.viaje_id,
      notas: "La unidad fue liberada",
      id_status: 8,
    });

    Swal.fire({
      title: "Unidad liberada",
      text: "La unidad ha sido liberada",
      icon: "success",
    });

    socket.emit("traer-unidades-en-ruta_", { idNegocio: unidad.negocio_id });
    hideSidebar();
  };

  const geocodeLatLng = (val_lat, val_long) => {
    const geocoder = new window.google.maps.Geocoder();
    const latlng = {
      lat: parseFloat(val_lat),
      lng: parseFloat(val_long),
    };

    geocoder
      .geocode({ location: latlng })
      .then((response) => {
        if (response.results[0]) {
          console.log(response.results[0].formatted_address);
          setForm({
            ...form,
            direccion: response.results[0].formatted_address,
          });
        } else {
          console.log("No results found");
        }
      })
      .catch((e) => console.log("Geocoder failed due to: " + e));
  };

  const puedeVerBitacora = user.rol !== "Invitado" || (user.negocio_id === 55 && user.rol === "Invitado");

  return (
    <>
      {loading && <Load />}
      <div>
        <div className="card-header p-2" id="card-header">
          Unidad {unidad.unidad_numero}
          <i className="icono-cerrar">
            <FontAwesomeIcon onClick={() => hideSidebar()} icon={faXmark} />
          </i>
        </div>

        <div
          className="card-body"
          style={{ overflowY: "scroll", maxHeight: "87vh" }}
        >
          {loadingComponente ? (
            <>
              <div className="text-center">
                <Spinner animation="border" variant="primary"></Spinner>
                <p className="p-1">Cargando datos del viaje...</p>
              </div>
            </>
          ) : (
            <div className="p-2">
              {(user.roles_id !== 6 && user.roles_id !== 8) && !viaje.evento_riesgo ? (
                <button
                  onClick={() => {
                    setActiModal(true);
                    setIdUnidad(unidad.unidad_id);
                  }}
                  className="btn btn-danger btn-block mb-4"
                  disabled={loading ? true : false}
                >
                  <FontAwesomeIcon icon={faUserSecret} /> &nbsp; Registro de
                  evento
                </button>
              ) : (
                ""
              )}
              <Accordion
                defaultActiveKey={user.rol !== "Invitado" ? "0" : "1"}
                flush
                onSelect={(key) => {
                  if (key === "3" && mapRef.current && marcadoresOrdenados.length > 0) {
                    setTimeout(() => {
                      if (marcadoresOrdenados.length === 1) {
                        mapRef.current.setCenter({ lat: marcadoresOrdenados[0].latitud, lng: marcadoresOrdenados[0].longuitud });
                        mapRef.current.setZoom(15);
                        return;
                      }
                      const bounds = new window.google.maps.LatLngBounds();
                      marcadoresOrdenados.forEach(p => bounds.extend({ lat: p.latitud, lng: p.longuitud }));
                      mapRef.current.fitBounds(bounds);
                    }, 300);
                  }
                }}
              >
                {puedeVerBitacora ? (
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>Bitácora</Accordion.Header>
                    <Accordion.Body>
                      <br />
                      {!viaje.evento_riesgo ? (
                        <>
                          <button
                            id="liberarUnidad"
                            disabled={loading ? true : false}
                            onClick={() => {
                              Swal.fire({
                                title: "¿Deseas liberar unidad?",
                                icon: "warning",
                                showCancelButton: true,
                                confirmButtonColor: "#3085d6",
                                cancelButtonColor: "#d33",
                                confirmButtonText: "¡Si!",
                                cancelButtonText: "No",
                              }).then((result) => {
                                if (result.isConfirmed && flujo === 1)
                                  return liberarUnidad();
                                if (result.isConfirmed && flujo === 2)
                                  return liberarUnidadViajeAutomatico();
                              });
                            }}
                            className="btn btn-secondary btn-block mb-4 mt-4"
                          >
                            <FontAwesomeIcon icon={faTruck} /> &nbsp; Liberar
                            Unidad
                          </button>
                          <hr />
                          {
                            (user.roles_id !== 6 && user.roles_id !== 8) && (
                              <>
                                <div className="row justify-content-center">
                                  {
                                    viaje.unidades_cajas.length !== 0 ?
                                      <>
                                        <div className="col-6 align-self-center">
                                          <h5>UNIDAD: {viaje?.unidad?.unidad_numero}</h5>
                                        </div>
                                        <div className="col-6 align-self-center">
                                          <TarjetaAperturaUnidad unidad_id={unidad.unidad_id} comandos={unidad.comands_logs} />
                                        </div>
                                        {
                                          viaje.unidades_cajas.map(({ caja }) => {
                                            return (
                                              <>
                                                <div className="col-6 align-self-center">
                                                  <h5>CAJA: {caja?.unidad_numero}</h5>
                                                </div>
                                                <div className="col-6 align-self-center">
                                                  <TarjetaAperturaUnidad unidad_id={caja?.unidad_id} comandos={[]} />
                                                </div>
                                              </>
                                            )
                                          })
                                        }
                                        {
                                          viaje?.complemento_viaje && (
                                            <>
                                              <div className="col-7 align-self-center">
                                                <h5>CONTENEDOR: {viaje?.complemento_viaje}</h5>
                                              </div>
                                              <div className="col-5">
                                                <h6 style={{ textAlign: "justify" }}>
                                                  <FontAwesomeIcon
                                                    icon={faTrailer}
                                                    style={{ color: "#2e333b", fontSize: '25px' }}
                                                  />
                                                </h6>
                                              </div>
                                            </>
                                          )
                                        }
                                      </> :
                                      <>
                                        <div className="col-6 align-self-center">
                                          <h5>UNIDAD: {viaje?.unidad?.unidad_numero}</h5>
                                        </div>
                                        <div className="col-6 align-self-center">

                                          <TarjetaAperturaUnidad unidad_id={unidad.unidad_id} comandos={unidad.comands_logs} />
                                        </div>
                                      </>
                                  }

                                </div>
                                <hr />
                              </>
                            )
                          }
                          <FormularioBitacora
                            viaje_id={viaje.viaje_id}
                            numeroUnidad={unidad.unidad_numero}
                            negocioId={unidad.negocio_id}
                            getUnidades={() => {
                              getUnidades();
                            }}
                            getBitacora={async () => {
                              let resp = await getBitacoraViaje(viaje.viaje_id);
                              if (resp.ok) setBitacora(resp.bitacora);
                              let lastItem = resp.ultimo;
                              setSeguimiento(lastItem);

                              setForm({
                                ...form,
                                notas: lastItem.notas,
                                ultimo_evento: lastItem.status.nombre,
                                direccion: lastItem.direccion,
                                lat: lastItem.latitud,
                                long: lastItem.longuitud,
                              });
                            }}
                            close={hideSidebar}
                            estateLoading={loading}
                            onSuccess={() => setIsChange(true)} // <- Callback de éxito
                          />
                          <br />
                        </>
                      ) : (
                        <p className="text-danger text-center">
                          {" "}
                          <b>Existe un evento de riesgo activado</b>
                        </p>
                      )}
                      <hr />
                      <div className="row overflow-auto">
                        <table className="table table-hover">
                          <thead className="thead-dark">
                            <tr>
                              <th scope="col"> Usuario</th>
                              <th scope="col">Evento</th>
                              <th scope="col">Hora</th>
                              <th scope="col">Descripcion</th>
                            </tr>
                          </thead>
                          <tbody>
                            {registrosCombinados.map((registro, index) => (
                              <tr
                                key={index}
                                style={registro.esTipoSeguridad ? { backgroundColor: "#fff3cd" } : {}}
                              >
                                <td>
                                  {registro?.monitoristum?.name}
                                </td>
                                <td>
                                  {registro.status?.icon && (
                                    <i className={`${registro.status.icon} me-1`}
                                      style={{ color: registro.status?.color }} />
                                  )}
                                  {registro.status?.nombre}
                                  {registro.esTipoSeguridad && (
                                    <span className="badge bg-danger ms-2" style={{ fontSize: "0.7rem" }}>
                                      Seguridad
                                    </span>
                                  )}
                                </td>
                                <td>{formatDate(registro.bitacora_fecha_hora)}</td>
                                <td>{registro.notas || "Sin comentarios"}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                ) : (
                  ""
                )}
                <Accordion.Item eventKey="1">
                  <Accordion.Header>Detalles de salida</Accordion.Header>
                  <Accordion.Body>
                    <div className="ibox-content">
                      <div className="row">
                        <div className="col">
                          <b>Negocio</b>
                        </div>
                        <div className="col">
                          {unidad.negocio && unidad.negocio.negocio_nombre}
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col">
                          <b>
                            {" "}
                            {unidad.cat_tipos_almacen
                              ? unidad.cat_tipos_almacen.nombre
                              : "Almacén"}
                          </b>
                        </div>
                        <div className="col">
                          {unidad.cedi && unidad.cedi.nombre_cedis}
                          {unidad.spot && (
                            <b className="text-warning mt-n4">
                              {" "}
                              (SPOT {unidad.nombre_transportadora})
                            </b>
                          )}
                        </div>
                      </div>
                      <hr />

                      <div className="row">
                        <div className="col">
                          <b>Eco</b>
                        </div>
                        <div className="col">{unidad.unidad_numero}</div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col">
                          <b>Cajas</b>
                        </div>
                        {viaje.unidades_cajas &&
                          viaje.unidades_cajas.length > 0 ? (
                          viaje.unidades_cajas.map((x) => {
                            return (
                              <>
                                <div className="col">
                                  {x.caja.unidad_numero}
                                </div>
                              </>
                            );
                          })
                        ) : (
                          <div className="col">SIN CAJAS ASIGNADAS</div>
                        )}
                      </div>
                      <hr />
                      {
                        viaje?.complemento_viaje && (
                          <>
                            <div className="row">
                              <div className="col">
                                <div className="col">
                                  <b>Contenedor</b>
                                </div>
                              </div>
                              <div className="col">{viaje?.complemento_viaje}</div>
                            </div>
                            <hr />
                          </>
                        )
                      }
                      <div className="row">
                        <div className="col">
                          <b>Estatus</b>
                        </div>
                        <div className="col">
                          {unidad && unidad.status && unidad.status.nombre}
                        </div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col">
                          <b>Fecha de salida</b>
                        </div>
                        <div className="col">
                          {viaje.fecha_hora_salida &&
                            viaje.fecha_hora_salida.substring(0, 10)}
                        </div>
                      </div>
                      <hr />

                      <div className="row">
                        <div className="col">
                          <b>Hora de salida</b>
                        </div>
                        <div className="col">
                          {viaje.fecha_hora_salida &&
                            viaje.fecha_hora_salida.substring(11, 16)}
                        </div>
                      </div>
                      <hr />
                      {
                        operador && (
                          <>
                            <div className="row">
                              <div className="col">
                                <b>Conductor</b>
                              </div>

                              <div className="col">
                                {operador.nombre_completo}
                                <br />
                              </div>
                            </div>

                            <div className="row">
                              <div className="col">
                                <b>Telefono</b>
                              </div>
                              <div className="col">
                                <a
                                  href={`tel:+52${operador.telefono}`}
                                  className="text-success"
                                >
                                  {operador.telefono}
                                </a>
                              </div>
                            </div>
                            <hr />
                          </>
                        )
                      }

                      {
                        chofer && (
                          <>
                            <div className="row">
                              <div className="col">
                                <b>Conductor</b>
                              </div>

                              <div className="col">
                                {chofer.nombre_completo}
                                <br />
                              </div>
                            </div>

                            <div className="row">
                              <div className="col">
                                <b>Telefono</b>
                              </div>
                              <div className="col">
                                <a
                                  href={`tel:+52${chofer.telefono}`}
                                  className="text-success"
                                >
                                  {chofer.telefono}
                                </a>
                              </div>
                            </div>
                            <hr />
                          </>
                        )
                      }

                      {tripulacion.length > 0 ? (
                        <>
                          <div className="row">
                            <div className="col-12">
                              <b>Acompañantes</b>
                            </div>
                            <div className="col">
                              {tripulacion.map((x) => {
                                if (!x.tripulante)
                                  return (
                                    <div>
                                      <label>Desconocido</label>
                                      <label>---</label>
                                    </div>
                                  );
                                return (
                                  <div key={x.tripulante_id}>
                                    <label>
                                      {x.tripulante
                                        ? x.tripulante.nombre_completo
                                        : "Desconocido"}
                                    </label>
                                    -
                                    <label>
                                      <a
                                        href={`tel:+52${x.tripulante.telefono}`}
                                        className="text-success"
                                      >
                                        {x.tripulante.telefono ||
                                          "Sin número telefónico"}
                                      </a>
                                    </label>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </>
                      ) : (
                        <div className="row">
                          <div className="col">
                            <b>Maniobra</b>
                          </div>
                          <div className="col">SIN MANIOBRA</div>
                        </div>
                      )}
                      <hr />

                      <div className="row">
                        <div className="col-12">
                          <b>Destinos</b>
                        </div>
                        <div className="col">
                          <ol>
                            {tiendasSeleccionadas.map((x) => {
                              return (
                                <li key={x.tienda_id}>
                                  {x.tienda.tienda_nombre}
                                </li>
                              );
                            })}
                          </ol>
                        </div>
                      </div>
                      <hr />
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>Datos de Validación</Accordion.Header>
                  <Accordion.Body>
                    <div className="ibox-content">
                      <div>
                        {formatoCheck.prueba_salida &&
                          formatoCheck.prueba_salida.paro_motor === 1 ? (
                          <div className="pull-right">
                            <span className="check-success pull-right">
                              <FontAwesomeIcon icon={faCheck} />
                            </span>
                          </div>
                        ) : (
                          <div className="pull-right">
                            <span className="check-secondary pull-right">
                              <FontAwesomeIcon
                                icon={faX}
                                style={{ color: "white" }}
                              />
                            </span>
                          </div>
                        )}
                        <p className="pruebaSalida">
                          PARO DE MOTOR
                          <br />
                          <small className="m-r">Prueba</small>
                        </p>
                      </div>
                      <hr />

                      <div>
                        {formatoCheck.prueba_salida &&
                          formatoCheck.prueba_salida.boton_panico === 1 ? (
                          <div className="pull-right">
                            <span className="check-success pull-right">
                              <FontAwesomeIcon icon={faCheck} />
                            </span>
                          </div>
                        ) : (
                          <div className="pull-right">
                            <span className="check-secondary pull-right">
                              <FontAwesomeIcon
                                icon={faX}
                                style={{ color: "white" }}
                              />
                            </span>
                          </div>
                        )}
                        <p className="pruebaSalida">
                          BOTÓN DE PÁNICO
                          <br />
                          <small className="m-r">Prueba</small>
                        </p>
                      </div>
                      <hr />

                      <div>
                        {formatoCheck.prueba_salida &&
                          formatoCheck.prueba_salida.conectividad === 1 ? (
                          <div className="pull-right">
                            <span className="check-success pull-right">
                              <FontAwesomeIcon icon={faCheck} />
                            </span>
                          </div>
                        ) : (
                          <div className="pull-right">
                            <span className="check-secondary pull-right">
                              <FontAwesomeIcon
                                icon={faX}
                                style={{ color: "white" }}
                              />
                            </span>
                          </div>
                        )}
                        <p className="pruebaSalida">
                          GPS ACTUALIZANDO
                          <br />
                          <small className="m-r">Prueba</small>
                        </p>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>Seguimiento</Accordion.Header>
                  <Accordion.Body>
                    {seguimiento && seguimiento.latitud === 0 ? (
                      <>
                        <div className="row g-4 align-items-center">
                          {/* <div className="col-2">
                            <label className="col-form-label">Latitud</label>
                          </div> */}
                          <div className="col-4">
                            <input
                              type="text"
                              className="form-control"
                              onChange={(event) => {
                                setForm({
                                  ...form,
                                  lat: parseFloat(event.target.value),
                                });
                              }}
                              style={{
                                padding: "5px",
                                height: "30px",
                                margin: "0",
                              }}
                              placeholder="Latitud"
                            />
                          </div>
                          {/* <div className="col-2">
                            <label className="col-form-label">Longitud</label>
                          </div> */}
                          <div className="col-4">
                            <input
                              type="text"
                              lass="form-control"
                              onChange={(event) => {
                                setForm({
                                  ...form,
                                  long: parseFloat(event.target.value),
                                });
                              }}
                              style={{
                                padding: "5px",
                                height: "30px",
                                margin: "0",
                              }}
                              placeholder="Longitud"
                            />
                          </div>
                          <div className="col-4">
                            <button
                              className="btn btn-primary"
                              style={{
                                padding: "5px",
                                margin: "10px 0",
                              }}
                              onClick={async (e) => {
                                try {
                                  geocodeLatLng(form.lat, form.long);
                                  seguimiento.latitud = form.lat;
                                  seguimiento.longuitud = form.long;

                                  const resp = await putCoordenadas(
                                    form.bitacora_monitorista_id,
                                    {
                                      latitud: `${parseFloat(form.lat)}`,
                                      longitud: `${parseFloat(form.long)}`
                                    }
                                  );

                                  if (resp.ok) {
                                    // Espera a que se actualice después de guardar
                                    await actualizarUltimoEvento(viaje.viaje_id);
                                  } else {
                                    console.error("Error al guardar coordenadas", resp.msg);
                                  }
                                } catch (error) {
                                  console.error("Error al guardar o actualizar:", error);
                                }
                              }}
                            >
                              Guardar
                            </button>
                          </div>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                    <div style={{ height: "400px", width: "auto" }}>
                      {isLoaded && seguimiento ? (
                        <>
                          <GoogleMap
                            mapContainerStyle={containerStyle}
                            center={{
                              lat: seguimiento ? seguimiento.latitud : 0,
                              lng: seguimiento ? seguimiento.longuitud : 0,
                            }}
                            zoom={16}
                            // onLoad={onMapLoad}
                            // onLoad={seguimiento ? onLoad : ""}
                            // onUnmount={seguimiento ? onUnmount : ""}
                            options={{
                              styles: [...demoFancyMapStyles],
                              clickableIcons: false,
                              mapTypeControl: false,
                            }}
                          >
                            {/* Línea de ruta */}
                            {/* <Polyline
                              path={rutaCoords}
                              options={{
                                strokeColor: "#a3a7a87b",
                                strokeOpacity: 0.9,
                                strokeWeight: 4,
                              }}
                            /> */}

                            {/* Marcador de posición actual */}
                            <Marker
                              position={{
                                lat: seguimiento ? seguimiento.latitud : 0,
                                lng: seguimiento ? seguimiento.longuitud : 0,
                              }}
                            />
                            {/* Ruta por carretera */}
                            {/* {directions && (
                              <DirectionsRenderer
                                directions={directions}
                                options={{
                                  suppressMarkers: true,      // ocultamos los marcadores A/B de Google
                                  polylineOptions: {
                                    strokeColor: "rgb(255, 193, 7)",
                                    strokeWeight: 5,
                                    strokeOpacity: 0.8,
                                  },
                                }}
                              />
                            )} */}

                            {/* Tus marcadores de eventos encima */}
                            {/* {marcadoresOrdenados.map((p) => (
                              <Marker
                                key={p.bitacora_monitorista_id}
                                position={{ lat: p.latitud, lng: p.longuitud }}
                                onClick={() => setInfoAbierta(p)}
                                label={{
                                  text: `${p.numero}`,
                                  color: "white",
                                  fontSize: "11px",
                                  fontWeight: "bold",
                                }}
                                icon={{
                                  path: window.google.maps.SymbolPath.CIRCLE,
                                  scale: 10,                          // un poco más grande para que quepa el número
                                  fillColor: p.status?.color ?? "#333",
                                  fillOpacity: 1,
                                  strokeColor: "white",
                                  strokeWeight: 1,
                                }}
                              />
                            ))}
                            {infoAbierta && (
                              <InfoWindow
                                position={{ lat: infoAbierta.latitud, lng: infoAbierta.longuitud }}
                                onCloseClick={() => setInfoAbierta(null)}
                              >
                                <div style={{ fontSize: "12px", maxWidth: "180px" }}>
                                  <b style={{ color: infoAbierta.status?.color }}>
                                    {infoAbierta.status?.nombre}
                                  </b>
                                  <br />
                                  <span>{formatDate(infoAbierta.bitacora_fecha_hora)}</span>
                                  <br />
                                  <span>{infoAbierta.notas}</span>
                                  <br />
                                  <small style={{ color: "#888" }}>{infoAbierta.direccion}</small>
                                </div>
                              </InfoWindow>
                            )} */}
                            {/* Child components, such as markers, info windows, etc. */}
                            <></>
                          </GoogleMap>
                          <div
                            className="watermark"
                            style={
                              seguimiento && seguimiento.latitud === 0
                                ? { top: "-489px" }
                                : {}
                            }
                          >
                            <img src={logotp_ma} alt="Marca de agua" />
                          </div>
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                    <div className="ibox-content">
                      <div className="row">
                        <div className="col-4">
                          <b>Unidad</b>
                        </div>
                        <div className="col-8">{unidad.unidad_numero}</div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col">
                          <b>Cajas</b>
                        </div>
                        {viaje.unidades_cajas &&
                          viaje.unidades_cajas.length > 0 ? (
                          viaje.unidades_cajas.map((x) => {
                            return (
                              <>
                                <div className="col-4">
                                  {x.caja.unidad_numero}
                                </div>
                              </>
                            );
                          })
                        ) : (
                          <div className="col-8">SIN CAJAS ASIGNADAS</div>
                        )}
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-4">
                          <b>Notas</b>
                        </div>
                        <div className="col-8">{form.notas}</div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-4">
                          <b>Estatus</b>
                        </div>
                        <div className="col-8">{form.ultimo_evento}</div>
                      </div>
                      <hr />
                      <div className="row">
                        <div className="col-4">
                          <b>Dirección</b>
                        </div>
                        <div className="col-8">{form.direccion}</div>
                      </div>
                      <div className="row">
                        <div className="col-4">
                          <b>Coordenadas</b>
                        </div>
                        <div className="col-8">
                          {seguimiento
                            ? `${seguimiento.latitud} , ${seguimiento.longuitud}`
                            : ""}
                        </div>
                      </div>
                      <hr />
                      <div className="row mt-3">
                        <h2>Histórico de eventos</h2>
                        <table className="table table-hover">
                          <thead className="thead-dark">
                            <tr>
                              <th scope="col">Evento</th>
                              <th scope="col">Hora</th>
                              <th scope="col">Descripcion</th>
                            </tr>
                          </thead>
                          <tbody>
                            {[...bitacora].reverse().map((registro, index) => {
                              return (
                                <tr key={index}>
                                  <td>{registro.status.nombre}</td>
                                  <td>
                                    {formatDate(registro.bitacora_fecha_hora)}
                                  </td>
                                  <td>{registro.notas || "Sin comentarios"}</td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </div>
          )}
        </div>
      </div>
      {actiModal ? (
        <RegistrarEditarEventoRoboCamiones
          idUnidad={idUnidad}
          mostrarModal={actiModal}
          onAction={modalClose}
          viaje={viaje}
          eventAction={"REGISTRAR"}
        />
      ) : (
        ""
      )}
    </>
  );
};
